import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import TimeSheetReportHeader from '../TimeSheetReports/TimeSheetReportHeader'
import { TimeSheetType } from '../../redux/timeSheet/timeSheetType';
import { RootState } from '../../redux/rootReducers';
import { EmptyListPage, ErrorSuccessModal, TableHeader, TableLoader } from '../commons';
import TimeSheetReportTable from '../TimeSheetReports/TimeSheetReportTable';
import { TIMESHEETREPORT_HEADERS } from '../../constant/timeSheetReportDropDown/timeSheetListConst';
import ScrollToTop from '../commons/ScrollToTop';
import InfiniteLoader from '../commons/InfiniteLoader/InfiniteLoader';
import { EmptyTimeSheetReportList } from '../../assets/images';
import { getTimeSheetUserReportAction, resetTimeSheetError, resetTimeSheetMessage, resetTimeSheetReportBillableTotalTime, resetTimeSheetReportListing, resetTimeSheetReportNonBillableTotalTime, resetTimeSheetReportTotalCount, resetTimeSheetReportTotalTime, resetTimeSheetStatusCode, resetTimeSheetSuccess,  } from '../../redux/timeSheet';
import { connect } from 'react-redux';
import { resetSession } from '../../redux/auth';
import { GetTimeSheetReportDataPayloadType } from '../../commonTypes/timeSheetTypes';
import { formatDate } from '../../utils/commonFunctions';
import './timesheet.scss';

type AppProps={
    isOpen:boolean;
    toggle:()=>void;
    fetching: boolean;
    token: string | null;
    timeSheetReportDataList: any[];
    totalTime: number ;
    statusCode: number | null;
    success: number | null;
    error: string | null;
    message: string | null;
    totalCount: string | number;
    isViewUserDropDown?:boolean;
    billableTotalTime:number;
    nonBillableTotalTime:number;
    dispatchGetTimeSheetUserReportDataAction:(data:any)=>void;
    dispatchResetTimeSheetTotalTime:()=>void;
    dispatchResetSession: () => void;
    dispatchResetTimeSheetReportSuccess: () => void;
    dispatchResetTimeSheetReportError: () => void;
    dispatchResetTimeSheetReportMessage: () => void;
    dispatchResetTimeSheetReportStatusCode: () => void;
    dispatchResetTimeSheetReportTotalCount: () => void;
    dispatchResetTimeSheetReportListing: () => void;
    dispatchResetTimeSheetBillableTotalTime:()=>void;
    dispatchResetTimeSheetNonBillableTotalTime:()=>void;
}

const OpenTimeSheetUserModal = ({
    isOpen,
    toggle,
    fetching,
    token,
    error,
    statusCode,
    success,
    message,
    totalCount,
    totalTime,
    billableTotalTime,
    nonBillableTotalTime,
    dispatchResetSession,
    timeSheetReportDataList,
    isViewUserDropDown,
    dispatchGetTimeSheetUserReportDataAction,
    dispatchResetTimeSheetReportSuccess,
    dispatchResetTimeSheetTotalTime,
    dispatchResetTimeSheetReportError,
    dispatchResetTimeSheetReportMessage,
    dispatchResetTimeSheetReportStatusCode,
    dispatchResetTimeSheetReportTotalCount,
    dispatchResetTimeSheetReportListing,
    dispatchResetTimeSheetBillableTotalTime,
dispatchResetTimeSheetNonBillableTotalTime

}:AppProps) => {
  
    const [data, setData] = useState<any>([]);
    const [offset, setOffset] = useState<number>(0);
    const [userId, setUserId] = useState<any>("");
    const [activityCode, setActivityCode] = useState<any>("");
    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");
    const [currentStartDate, setCurrentStartDate] = useState<string>("");
  const [currentEndDate, setCurrentEndDate] = useState<string>("");
  const [limit, setLimit] = useState(20);
  const [type , setType] = useState("");

  const scrollRef = useRef<any>('')

    useEffect(() => {
        dispatchResetTimeSheetReportSuccess();
        dispatchResetTimeSheetReportError();
        dispatchResetTimeSheetReportMessage();
        dispatchResetTimeSheetReportStatusCode();
        dispatchResetTimeSheetReportTotalCount();
        dispatchResetTimeSheetReportListing();
        dispatchResetTimeSheetTotalTime();
        dispatchResetTimeSheetBillableTotalTime();
        dispatchResetTimeSheetNonBillableTotalTime();
      }, []);

      useEffect(() => {
        if (timeSheetReportDataList?.length === 0) {
          setData(timeSheetReportDataList);
        }
        if (offset > 0) {
          setData((prv: any) => [...prv, ...timeSheetReportDataList]);
        } else {
          setData(timeSheetReportDataList);
        }
      }, [timeSheetReportDataList]);

      useEffect(() => {
        dispatchResetTimeSheetReportTotalCount();
        if (token) {
          if (startDate && endDate) {
            let finalData: any = {
              token,
              limit,
              offset,
              startDate: formatDate(startDate),
              endDate: formatDate(endDate),
              userId,
              activityCode,
              type,
            };
    
            if (offset < +totalCount) {
              dispatchGetTimeSheetUserReportDataAction(finalData);
            } else if (offset === 0 && totalCount === "") {
              dispatchGetTimeSheetUserReportDataAction(finalData);
            }
          }
        }
      }, [offset]);

      const handleScrolll = useCallback((event:any) => {
          const scrollTop = scrollRef.current.scrollTop;
            const scrollHeight = scrollRef.current.scrollHeight
            const clientHeight = scrollRef.current.clientHeight;
             if (Math.ceil( 75/100*scrollHeight)<=scrollTop + clientHeight) {
          if (timeSheetReportDataList?.length > 0) {
           
             setOffset(offset + limit)
              
            }
          }
    }, [timeSheetReportDataList]);

    useEffect(() => {
      let x = scrollRef.current;
      if (x) {
        
        scrollRef.current.addEventListener('scroll', handleScrolll)
        return () => x.removeEventListener('scroll', handleScrolll)
      }
      },[timeSheetReportDataList])
    
    const handleSubmitData = (data: any) => {
      dispatchResetTimeSheetTotalTime()
      setCurrentStartDate(data?.startDate);
      setCurrentEndDate(data?.endDate)
        window.scrollTo(0, 0);
        setData([]);
        if (token) {
          let finalData: any = {
            token,
            userId,
            activityCode,
            type,
            ...data,
          };
          if (offset === 0) {
            dispatchGetTimeSheetUserReportDataAction(finalData);
          } else {
            setOffset(0);
          }
    
        }
      };


      const handleErrorModal = () => {
        if (success === 0) {
          if (statusCode === 401) {
            return (
              <ErrorSuccessModal
                type="error"
                isOpen={!!error}
                title="Error"
                message="Session Expired. Please Login Again!"
                buttonText="Logout"
                onPress={() => dispatchResetSession()}
                statusCode={statusCode}
              />
            );
          } else if (!!error && statusCode !== 401) {
            return (
              <ErrorSuccessModal
                type="error"
                isOpen={!!error}
                title="Error"
                message={error}
                buttonText="OK"
                onPress={() => {
                  dispatchResetTimeSheetReportError();
                }}
              />
            );
          }
        }
        if (success === 1 && message === "Timesheet list fetched successfully!") {
          dispatchResetTimeSheetReportMessage();
          dispatchResetTimeSheetReportSuccess();
          dispatchResetTimeSheetReportListing();
        }
    
        return false;
      };
  return (
    <div>
        <Modal
        centered
        isOpen={isOpen}
        toggle={toggle}
        size='xl'
        backdrop="static"
        // keyboard={false}
    
      >
            <ModalHeader className="pt-3 pl-4" id='cross-cut' toggle={toggle} style={{paddingBottom:"13px"}}>
            Download Timesheet Report
          </ModalHeader>
        <ModalBody className='pl-4 pr-4' style={{ paddingLeft: "40px" }}>
            <>
            <div ref={scrollRef} className='pl-1' style={{ height:"400px" ,overflow:"scroll"}}>

            <TimeSheetReportHeader    
            handleSubmitData={handleSubmitData} 
            isViewUserDropDown={isViewUserDropDown}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            startDate={startDate}
            endDate={endDate}
            setUserId={setUserId}
            setActivityCode={setActivityCode}
            setType={setType}
            />
                    <hr className="mt-4 mb-4" />

               <div className="col-md-12 mt-4 pb-2">
          <>
            {fetching && offset===0? (
                <TableLoader Rows={10} ColumnPerRow={7} />
                ) : timeSheetReportDataList?.length > 0 ? (
                  <div className="jobsType">
                    <table className="table thead-light table-bordered">
                      <thead className="text-start sticky-table-header-without-zindex">
                        <tr className="new-table-head" style={{fontSize:"11px"}}>
                          <td>
                            <strong>TOTAL  Hrs : {typeof(totalTime)==="number"&&totalTime?totalTime.toFixed(2):0}</strong>
                          </td>
                          <td>
                            <strong>BILLABLE TOTAL Hrs : {typeof(billableTotalTime)==="number"&&billableTotalTime?billableTotalTime.toFixed(2):0}</strong>
                          </td>
                          <td>
                            <strong>NON BILLABLE TOTAL Hrs : {typeof(nonBillableTotalTime)==="number"&&nonBillableTotalTime?nonBillableTotalTime.toFixed(2):0}</strong>
                          </td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <TableHeader tableHeader={TIMESHEETREPORT_HEADERS} />
                      </thead>
                      <tbody>
                        <TimeSheetReportTable
                          data={data}
                          tableHeaders={TIMESHEETREPORT_HEADERS}

                          />
                          <span style={{zIndex:100 ,position:"relative"}}><ScrollToTop /></span>
                        {fetching && offset > 0 && (
                            <div>{<InfiniteLoader />}</div>
                            )}
                      </tbody>
                    </table>
                  </div>
            ) : (
                <>
                {!fetching && data?.length === 0 && (
                    <EmptyListPage
                    title="No Timesheet List!"
                    text="Select date range to see time sheet list!"
                    imageWidth="30%"
                    image={EmptyTimeSheetReportList}
                    showAddButton={false}
                    />
                    )}
              </>
            )}
          </>
            </div>

            </div>
            </>
            
        </ModalBody>
      </Modal>
      {handleErrorModal()}

    </div>
  )
}
const mapStateToProps = (state: RootState) => ({
    token: state.auth.token,
    error: state.timeSheet.error,
    statusCode: state.timeSheet.statusCode,
    success: state.timeSheet.success,
    message: state.timeSheet.message,
    fetching: state.timeSheet.fetching,
    totalTime: state.timeSheet.reportTotalTime,
    billableTotalTime:state.timeSheet.reportTotalBillableTime,
    nonBillableTotalTime:state.timeSheet.reportTotalNonBillableTime,
    activityCodeListing: state.masterData.masterDataActivivtyCodeListing,
    timeSheetReportDataList: state.timeSheet.timeSheetReportDataList,
    totalCount: state.timeSheet.timeSheetReportTotalCount,
  });

  const mapDispatchToProps = (dispatch: any) => ({
    
    dispatchResetSession: () => dispatch(resetSession()),
    dispatchResetTimeSheetReportSuccess: () =>
      dispatch(resetTimeSheetSuccess()),
    dispatchResetTimeSheetReportError: () =>
      dispatch(resetTimeSheetError()),
    dispatchResetTimeSheetReportMessage: () =>
      dispatch(resetTimeSheetMessage()),
    dispatchResetTimeSheetReportStatusCode: () =>
      dispatch(resetTimeSheetStatusCode()),
    dispatchResetTimeSheetReportTotalCount: () =>
      dispatch(resetTimeSheetReportTotalCount()),
    dispatchResetTimeSheetReportListing: () =>
      dispatch(resetTimeSheetReportListing()),
    dispatchGetTimeSheetUserReportDataAction: (data: GetTimeSheetReportDataPayloadType) =>
    dispatch(getTimeSheetUserReportAction(data)),
    dispatchResetTimeSheetTotalTime:()=>dispatch(resetTimeSheetReportTotalTime()),
    dispatchResetTimeSheetBillableTotalTime:()=>dispatch(resetTimeSheetReportBillableTotalTime()),
    dispatchResetTimeSheetNonBillableTotalTime:()=>dispatch(resetTimeSheetReportNonBillableTotalTime())

  });


export default connect(mapStateToProps,mapDispatchToProps)(OpenTimeSheetUserModal)
